import {Inject, injectable} from 'inversify-props';

import {SystemInfo} from '@/model/system/SystemInfo';
import {SoftwareDetails} from '@/model/system/SoftwareDetails';

import {IApiService} from '@/services/IApi.service';
import {ISystemInfoService} from '@/services/system/IInfo.service';
import {TypedJSON} from 'typedjson';

@injectable()
export class SystemInfoService implements ISystemInfoService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/system/info';

  private systemInfoSerializer = new TypedJSON(SystemInfo);

  private softwareDetailsSerializer = new TypedJSON(SoftwareDetails);

  public async getInfo(): Promise<SystemInfo> {
    return this.systemInfoSerializer.parse(await this.apiService.get(this.path))!;
  }

  public async getSoftwareDetails(): Promise<SoftwareDetails[]> {
    const ret = await this.apiService.get(`${this.path}/software-details`);
    return ret.map((d: any) => this.softwareDetailsSerializer.parse(d));
  }
}
